module.exports = new __parcel__URL__("albums.89f53e45.png").toString();